import Vue from 'vue';

export default new Vue();



// WEBPACK FOOTER //
// ./src/libs/eventBus.js